import IKnowSequencer from 'es6/controllers/apps/iknow-sequencer';

/*
 * Essentially the same as the iKnow sequencer, but doesn't insert extra
 * quizzes following incorrect or hard answers.
 */
export default class SelfAssessmentSequencer extends IKnowSequencer {

  /*
   * Note: Because we expect longer sequences in Quick Review modes (self-assessment
   * & rapid choice) we might want to expand out the intervalMultipliers over more
   * steps.
   */

  /*
   * @Override
   * Don't want to insert an extra quiz in the same way we do in iknow.
   */
  _onHardAnswer(studyItem) {
    // Do nothing
  }

  /*
   * @Override
   * Don't want to insert an extra quiz following an incorrect answer.
   */
  _attemptInsertingExtraQuiz(studyItem) {
    // Do nothing
  }

  /*
   * @Override
   * Don't want to replace with an identical quiz; want to add the SABinary
   * quiz listed as the followup instead.
   */
  _getReplacementForIncorrectQuiz(quiz, studyItem) {
    return new quiz.followUpQuiz(
      quiz.itemPackage,
      quiz.result.goalId,
      this._isDiagnosticQuiz,
      this.quizFinished.bind(this),
      this._quizTimer
    );
  }
}
